import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import contactService from "../../api/contactService";

// Action flags
export const ACTION_FLAGS = {
  SUBMIT_CONTACT_FORM: "contact/submitForm",
};

// Async thunk for submitting contact form
export const submitContactForm = createAsyncThunk(
  ACTION_FLAGS.SUBMIT_CONTACT_FORM,
  async (formData, { rejectWithValue }) => {
    try {
      const response = await contactService.createSupport(formData);
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.message ||
        "Failed to send message";
      return rejectWithValue(message);
    }
  },
);

// Initial state
const initialState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  errorMessage: "",
  successMessage: "",
};

const contactSlice = createSlice({
  name: "contact",
  initialState,
  reducers: {
    // Reset state
    resetContactState: (state) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.isError = false;
      state.errorMessage = "";
      state.successMessage = "";
    },
    // Clear messages
    clearMessages: (state) => {
      state.successMessage = "";
      state.errorMessage = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitContactForm.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
        state.errorMessage = "";
      })
      .addCase(submitContactForm.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.successMessage =
          action.payload.message || "Message sent successfully!";
        state.errorMessage = "";
      })
      .addCase(submitContactForm.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
        state.successMessage = "";
      });
  },
});

export const { resetContactState, clearMessages } = contactSlice.actions;
export default contactSlice.reducer;
